import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../config/msalConfig';
import useStore from '../../store';
import { POST_LOGIN_REDIRECT_KEY } from './postLoginRedirect';
import './LoginPage.css';

export default function LoginPage() {
  const { instance } = useMsal();
  const navigate     = useNavigate();
  const location     = useLocation();
  const { token }    = useStore();

  // Where RequireAuth sent the user from, e.g. /attendance from an email link
  const from = location.state?.from;
  const redirectTarget = from ? `${from.pathname}${from.search || ''}` : null;

  useEffect(() => {
    if (token) navigate(redirectTarget || '/dashboard', { replace: true });
  }, [token]);

  const handleLogin = () => {
    // MSAL does a full-page redirect to Microsoft, so router state won't
    // survive — stash the intended destination in sessionStorage instead.
    if (redirectTarget) {
      sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, redirectTarget);
    }
    instance.loginRedirect(loginRequest);
  };

  return (
    <div className="login-page">
      <div className="login-bg">
        <div className="login-orb login-orb-1" />
        <div className="login-orb login-orb-2" />
        <div className="login-orb login-orb-3" />
      </div>

      <div className="login-card">
        <div className="login-logo">
          <div className="login-logo-mark">A</div>
          <span className="login-logo-text">Aays</span>
        </div>

        <h1 className="login-title">Employee Portal</h1>
        <p className="login-subtitle">
          Sign in with your AAYS Microsoft account to continue
        </p>

        <button className="btn-sso" onClick={handleLogin}>
          <svg width="20" height="20" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0H0v10h10V0z" fill="#F25022"/>
            <path d="M21 0H11v10h10V0z" fill="#7FBA00"/>
            <path d="M10 11H0v10h10V11z" fill="#00A4EF"/>
            <path d="M21 11H11v10h10V11z" fill="#FFB900"/>
          </svg>
          Sign in with Microsoft
        </button>

        <p className="login-footer">
          By signing in you agree to AAYS's{' '}
          <a href="#privacy">Privacy Policy</a> and{' '}
          <a href="#terms">Terms of Service</a>.
        </p>
      </div>
    </div>
  );
}
